import api from '../../helpers/api';
import {
    IGetGamesRequest,
    IMatch,
    IMatchesState,
    ISeasonData,
    IUserStats,
    IPerformanceStats,
} from './Matches-types';
import Router from '../../router';
import { IUserPayload } from '../Users/Users-types';
import { IUnitTypeResource } from '../Unit/Unit-types';

const matchesState: IMatchesState = {
    state: {
        currentPage: 1,
        games: [],
        loaded: false,
        metadata: null,
        pages: [],
        profileUserId: null,
        selectedOpponent: null,
		seasons: [],
        selectedUnitTypes: [],
        unitTypes: [],
        unitsOnSameTeam: false,
        performanceStats: null,
        performanceStatsLoaded: false,
		aiProfile: false,
    },
    mutations: {
        setGames(state, games: IMatch[]) {
            state.games = games;
        },
        setGamesLoaded(state, loaded: boolean) {
            state.loaded = loaded;
        },
        setMetadata(state, metadata: IUserStats) {
            state.metadata = metadata;
        },
        setPages(state, pages: number[]) {
            state.pages = pages;
        },
        setCurrentPage(state, currentPage: number) {
            state.currentPage = currentPage;
        },
        setProfileUserId(state, userId: string) {
            state.profileUserId = userId;
        },
		setSeasons(state, seasons: ISeasonData[]) {
			state.seasons = seasons;
		},
        setSelectedOpponent(state, selectedOpponent: string) {
            state.selectedOpponent = selectedOpponent;
        },
        setAllUnitTypes(state, unitTypes: IUnitTypeResource[]) {
            state.unitTypes = unitTypes;
        },
        setSelectedUnitTypes(state, selectedUnitTypes: IUnitTypeResource[]) {
            state.selectedUnitTypes = selectedUnitTypes;
        },
        setUnitsOnSameTeam(state, value: boolean) {
            state.unitsOnSameTeam = value;
        },
        setPerformanceStats(state, stats: IPerformanceStats) {
            state.performanceStats = stats;
        },
        setPerformanceStatsLoaded(state, loaded: boolean) {
            state.performanceStatsLoaded = loaded;
        },
		setAiProfile(state, aiProfile: boolean) {
			state.aiProfile = aiProfile;
		}
    },
    actions: {
        async getGames({ commit, state }, options: IGetGamesRequest) {
            commit('setGamesLoaded', false);
			commit('setGames', []);
            commit('setCurrentPage', options.page);

            const {
                page,
                opponentUuid,
                unitTypeIds,
                username,
                unitsOnSameTeam,
				aiView,
            } = options;

            let url = `/user/games?page=${page}`;

            if (username) {
                url += `&username=${username}`;
            }

            if (opponentUuid) {
                url += `&filters[opponentUuid]=${opponentUuid}`;
            }

            if (opponentUuid) {
                url += `&filters[opponentUuid]=${opponentUuid}`;
            }

            if (unitTypeIds.length) {
                url += `&filters[unitTypeIds]=${unitTypeIds.join(',')}`;
            }

            if (unitsOnSameTeam) {
                url += '&filters[unitsOnSameTeam]=true';
            }

			if (aiView) {
                url += '&filters[aiView]=true';
            }

            const response = await api.request(url, 'GET');

            if (response.ok) {
                const gamesResponse = await response.json();
                commit('setGames', gamesResponse.data);
                commit('setGamesLoaded', true);

                if (gamesResponse.pages !== state.pages) {
                    const pages = [];

                    for (let i = 0; i < gamesResponse.pages; i++) {
                        pages.push(i + 1);
                    }

                    commit('setPages', pages);
                }
            }

            if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
        async getMetadata({ commit }, username) {
            commit('setProfileUserId', null);
            commit('setAiProfile', false);

            let url = '/user/metadata';

            if (username) {
                url = `/user/${username}/metadata`;
            }

            const response = await api.request(url, 'GET');
            const metadata = await response.json();

            if (response.ok) {
                commit('setProfileUserId', metadata.id);
                commit('setAiProfile', metadata.ai);
                commit('setMetadata', metadata);
                commit('setPages', new Array(Math.ceil(metadata.games / 10)));
            }

            if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
		async getUserSeasons({ commit }, username) {
            const url = `/season/${username}/all`;

            const response = await api.request(url, 'GET');
            const seasons = await response.json();

            if (response.ok) {
                commit('setSeasons', seasons);
            }

            if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
        async getAllUnitTypes({ commit }) {
            const response = await api.request('/unitType/get', 'GET');

            if (response.ok) {
                const unitTypes = await response.json();
                unitTypes.sort((unitTypeA, unitTypeB) => unitTypeA.name.localeCompare(unitTypeB.name));
                commit('setAllUnitTypes', unitTypes);
            }
        },
        setGamesLoaded({ commit }, loaded: boolean) {
            commit('setGamesLoaded', loaded);
        },
        setSelectedOpponent({ commit }, opponent: IUserPayload) {
            commit('setSelectedOpponent', opponent);
        },
        setSelectedUnitTypes({ commit }, setSelectedUnitTypes: IUnitTypeResource[]) {
            commit('setSelectedUnitTypes', setSelectedUnitTypes);
        },
        setUnitsOnSameTeam({ commit }, value: boolean) {
            commit('setUnitsOnSameTeam', value);
        },
        async getPerformanceStats({ commit }, { username, days = 1 }) {
            commit('setPerformanceStatsLoaded', false);

            let url = '/user/performance-stats?days=' + days;

            if (username) {
                url += '&username=' + username;
            }

            const response = await api.request(url, 'GET');

            if (response.ok) {
                const stats = await response.json();
                commit('setPerformanceStats', stats);
                commit('setPerformanceStatsLoaded', true);
            }

            if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
    },
};

export default matchesState;
